import Filters2 from './filters';

export default Filters2;
